import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';
import { TimelineSummary } from '../models/timeline-summary.model';

// The engagement's timelines in brief: the main and one per buyer who has their own. The Buyers tab
// reads it to know which timeline is which buyer's, so a buyer's row can count that timeline's badges.
export const GetEngagementTimelines = createAsyncThunk(
    'engagements/GetEngagementTimelines',
    async (engagementId: number, dispatch: any): Promise<TimelineSummary[]> => {
        const axios = dispatch.getState().core.axios;
        try {
            const response = await axios.get(`/api/Marketplace/Engagements/${engagementId}/timelines`);
            if (response.status !== 200) {
                throw new Error('Failed to fetch the engagement timelines');
            }
            return response.data;
        } catch (error) {
            createNotification('An error occurred while fetching the engagement timelines.', 'error');
            throw error;
        }
    }
);
